import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iCellLineFilterSaveState{
    response: any;
    isLoading: boolean;
    message: string | null;
} 
const initialState: iCellLineFilterSaveState = {
    response: null,
    isLoading: false,
    message: "",
};
export const cellLineFilterSaveAPI = createAsyncThunk(
    "cellLineFilterSaveAPI",
    async (params: {
        group_name: string;
        library_name: string;
        round: number;
        workflow_name: string;
        cell_lines: string[];
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/cell-lines-filter-save/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                group_name: params.group_name,
                library_name: params.library_name,
                round: params.round,
                workflow_name: params.workflow_name,
                cell_lines: params.cell_lines
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const cellLineFilterSaveSlice = createSlice({
    name: "cellLineFilterSave",
    initialState,
    reducers: {
        resetCellLineFilter: (state) => {
            state.response = null;
            state.isLoading = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(cellLineFilterSaveAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(cellLineFilterSaveAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(cellLineFilterSaveAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    }
});

export const { resetCellLineFilter } = cellLineFilterSaveSlice.actions;
export default cellLineFilterSaveSlice.reducer;